import React from "react";
import { TruncateTooltip } from "./TruncateTooltip";
import { useIsTruncated } from "../hooks/useIsTruncated";

interface Props {
    text: string;
    className?: string;
    children?: React.ReactNode;
}

export const TruncatedTooltipText: React.FC<Props> = ({ text, className, children }) => {
    const [ref, isTruncated] = useIsTruncated<HTMLDivElement>();
    return (
        <div className={`truncate ${className ?? ""}`} ref={ref}>
            {isTruncated ? (
                <TruncateTooltip button={<span>{children ?? text}</span>} text={text} />
            ) : (
                children ?? text
            )}
        </div>
    );
}; 